let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aKH6G")).then(() => parcelRequire('5t3rF'));